export default "__VITE_ASSET__CesJCrBG__"